$ = require 'jquery'
BoardAddToOrganizationView = require 'views/board-menu/board-add-to-organization-view'
AddListPopoverView = require 'views/board/add-list-popover-view'
Auth = require 'db/auth'
Backgrounds = require 'data/backgrounds'
BoardCleanUpView = require 'views/board/board-clean-up-view'
BoardDescView = require 'views/board/board-desc-view'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
BoardHeaderOrgMenuView = require 'views/board/board-header-org-menu-view'
BoardSidebarView = require 'views/board-menu/board-sidebar-view'
BoardTagSelectView = require 'views/organization/board-tag-select-view'
CalendarControllerView = require 'views/calendar/calendar-controller-view'
Card = require 'models/card'
{ canAddCard } = require 'views/card/card-limits-error'
CardListView = require 'views/card/card-list-view'
CardView = require 'views/card/card-view'
ChangeBoardVisibilityView = require 'views/board-menu/change-board-visibility-view'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
CopyBoardHeaderButtonTeams = require 'data/copy-board-header-button-teams'
CopyBoardView = require 'views/board/copy-board-view'
Dialog = require 'views/lib/dialog'
DirectoryView = require 'views/directory/directory-view'
DragSort = require 'views/lib/drag-sort'
FavIcon = require 'lib/favicon'
IdCache = require 'db/id-cache'
Keys = require 'data/keys'
LabelState = require 'view-models/label-state'
Layout = require 'views/lib/layout'
LegacyPowerUps = require 'data/legacy-power-ups'
Limits = require 'lib/limits'
ListListView = require 'views/list/list-list-view'
ListView = require 'views/list/list-view'
MemberBoardProfileView = require 'views/member/member-board-profile-view'
ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
PluginHeaderButtonsView = require 'views/plugin/plugin-header-buttons-view'
PopOver = require 'views/lib/pop-over'
RenameBoardView = require 'views/board-menu/rename-board-view'
Storage = require 'lib/storage'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
closedTemplate = require 'views/templates/board_closed'
getExperiment = require 'lib/experiments/simple-test'
l = require 'lib/localize'
log = require 'debug/log'
ninvoke = require 'lib/util/ninvoke'
templates = require 'views/internal/templates'
headerTemplate = require 'views/templates/board_header'
permsTemplate = require 'views/templates/board_header_permissions'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
warningTemplate = require 'views/templates/board_header_warnings'
{ trackUnsplashViewBySavedUrl } = require 'network/unsplash'

BoardHeaderAllMembersView = require 'views/board/board-header-all-members-view'
MemberOnBoardView = require 'views/member-menu-profile/member-on-board-view'
BoardMembersView = require 'views/board-menu/board-members-view'
BoardMemberAddMultipleView = require 'views/board-menu/board-member-add-multiple-view'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

module.exports = class BoardView extends View

  className: 'board-wrapper'

  events:
    'sortcommit': 'sortCommit'

    'click .js-rename-board': 'renameBoard'
    'click .js-open-org-menu': 'openOrgMenu'

    'click .js-add-board-to-team:not(.no-edit)': 'addBoardToTeam'
    'click .js-change-vis': 'changeVis'
    'click .js-open-desc': 'openDesc'
    'click .js-close-calendar': 'toggleCalendar'
    'click .js-calendar': 'toggleCalendar'
    'click .js-collection': 'toggleOpenCollections'

    'click .js-filter-cards-indicator': 'openFilter'
    'click .js-filter-card-clear': 'clearFilters'
    'click .js-board-header-subscribed': 'openUnsubscribe'

    'click .js-star-board': 'toggleStarred'

    'click .js-show-sidebar': 'setSidebarShow'

    'click .js-dismiss-warning': (e) ->
      Storage.set(@$(e.currentTarget).attr('data-dismiss'), Date.now())
      @renderBoardWarnings()

    'dblclick #board': 'dblClickAddListMenu'

    'click .js-reopen': 'reopen'
    'click .js-delete': 'delete'

    'click .js-clean-up': 'showCleanUp'

    'shortcut': 'shortcut'
    'prevent-scroll-selection': 'preventScrollSelection'

    'click .js-close-directory': 'toggleDirectory'

    'click .js-copy-board': 'copyBoard'
    'click .js-open-show-all-board-members': 'openAllMembers'
    'click .js-open-manage-board-members': 'openAddMembers'
    'click .js-join-board': 'joinBoard'

  initialize: ->
    super

    @sidebarView = @subview BoardSidebarView, @model, { boardView: @ }

    @makeDebouncedMethods 'refreshOrganization',
      'reloadCustomFields'
      'render'
      'renderBoardBackground'
      'renderBoardHeader'
      'renderBoardHeaderCalendar'
      'renderBoardHeaderDescription'
      'renderBoardHeaderSubscribed'
      'renderBoardWarnings'
      'renderLists'
      'renderPermissionLevel'
      'updateControllerTitle'
      'renderBoardHeaderFacepile'
      'renderPluginButtons'

    @listenTo @model,
      'change:closed deleting': @renderDebounced
      'change:desc': @renderBoardHeaderDescriptionDebounced
      'change:idOrganization': @refreshOrganizationDebounced
      'change:memberships': @renderPermissionLevelDebounced
      'change:limits': @renderBoardWarningsDebounced
      'change:name': =>
        @renderBoardHeaderDebounced()
        @updateControllerTitleDebounced()
      'change:powerUps': ->
        @renderBoardHeaderCalendarDebounced()
        if !@model.isPowerUpEnabled('calendar')
          @closeCalendar()
      'change:prefs.cardCovers': @renderListsDebounced
      'change:prefs.permissionLevel': =>
        @renderListsDebounced()
        @renderPermissionLevelDebounced()
      'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness': =>
        @renderBoardBackgroundDebounced(true)
        @renderPluginButtonsDebounced()
      'change:subscribed': @renderBoardHeaderSubscribedDebounced
      'permChange': @permChange
      'ownedChange': @renderBoardHeaderDebounced
      'destroy': =>
        Controller.displayErrorPage
          errorType: 'boardNotFound'

    @listenTo @model.memberList,
      'change:status': @renderBoardHeaderDebounced
      'add remove reset': @renderBoardHeaderFacepileDebounced

    @listenTo @model.boardPluginList, 'add reset', =>
      @reloadCustomFieldsDebounced()

    @subscribe pluginsChangedSignal(@model), =>
      @renderBoardHeaderCalendarDebounced()
      if !@model.isPowerUpEnabled('calendar')
        @closeCalendar()

    @listenTo @model.viewState,
      'change:showSidebar': @renderSidebarState
      'change:sidebarDisplayType': @renderSidebarDisplayType

    @listenTo Auth.me().boardStarList, 'add remove reset', =>
      @renderBoardHeaderStarred()

    @memberTypeMe = @model.getMemberType(Auth.me())

    @refreshOrganization()

    @listScrollLeft = null
    @savingScroll = false
    @calcState = {}

    @listenTo @model.filter, 'change', @renderFilteringStatus

    UserInput.addHandler @, { scope: 'board' }

    @listListView = @collectionSubview ListListView, @model.listList,
      id: 'board'
      model: @model
      className: 'u-fancy-scrollbar js-no-higher-edits'
      resetCallback: => @postListListRender()


    # Why are we listening to mousemove? Isn't mouseenter sufficient?
    #
    # 1. Hover your mouse over a card
    # 2. Hit an arrow key, moving the selected card, but not in a way that
    #    scrolls the page -- so the mouse is still hovering over the original
    #    card view.
    # 3. Move your mouse.
    #
    # If we were only listening to mouseenter, we'd never select the card,
    # because the mouse didn't re-enter it.
    @listenTo @listListView,
      'mouseMoveListView': (listView) ->
        list = listView.model
        @model.viewState.selectList listView.model
      'mouseLeaveListView': (listView) ->
        list = listView.model
        @model.viewState.selectList null
      'mouseMoveCardView': (listView, cardView) ->
        if @ignoreMouseCardSelects || PopOver.isVisible || DragSort.sorting
          return
        @model.viewState.selectCard cardView.model
      'mouseLeaveCardView': (listView, cardView) ->
        if @ignoreMouseCardSelects || PopOver.isVisible || DragSort.sorting
          return
        @model.viewState.selectCard null
      'moveCard': @moveCardRequested
      'copyCard': @copyCardRequested

    @_applySettings()
    @markRelatedNotificationsRead()
    return

  _applySettings: ->
    if !@options.settings?
      return

    { menu, filter } = @options.settings

    switch menu
      when 'closed'
        @model.viewState.setShowSidebar(false)
      when 'filter', 'activity'
        @setSidebarShow()
        @sidebarView.pushView(menu)

    if filter
      @model.filter.fromQueryString(filter)

  permChange: (newPerm) ->
    if newPerm == 'none'
      Controller.memberHomeView()
    else
      @render()
      # If we can't edit the board, hide the card composer (if it's open)
      if !@model.editable()
        @model.composer.save('vis', false)
    return

  shortcut: (key) ->
    editable = @model.editable()
    isLoggedIn = Auth.isLoggedIn()

    switch key
      when Keys.Q
        if isLoggedIn
          @model.filter.toggleQuietMode()
          "Q - My cards"

      when Keys.X
        @model.filter.clear()
        "X - Clear All Filters"

      when Keys.W
        @toggleSidebar()
        "W - Toggle Board Sidebar"

      when Keys.Semicolon
        wasShowingLabelText = LabelState.getShowText()
        LabelState.toggleText()
        track(
          "Toggle Labels Text on Card Front",
          if wasShowingLabelText then "Hide" else "Show",
          @model.id,
          "shortcut"
        )
        "; - Toggle Label Text"

      when Keys.ArrowDown, Keys.J
        @moveCard('down')
        ["Keyboard Nav", "Down"]

      when Keys.ArrowUp, Keys.K
        @moveCard('up')
        ["Keyboard Nav", "Up"]

      when Keys.ArrowRight
        @moveCard('right')
        ["Keyboard Nav", "Right"]

      when Keys.ArrowLeft
        @moveCard('left')
        ["Keyboard Nav", "Left"]

      when Keys.N
        if editable
          list = @model.viewState.getList()
          card = @model.viewState.getCard()

          if list?
            index =
              if card?
                list.openCards().indexOf(card) + 1
              else
                list.openCards().length

            @model.composer.save({
              list: list
              index: index
              vis: true
            })

            "N - Insert Card"

      when Keys.Escape
        if editable

          if DragSort.sorting
            DragSort.abort()
          else if !(Layout.isEditing() || PopOver.isVisible || Dialog.isVisible)
            if @model.composer.get('vis')
              @model.composer.save("vis", false)
            else if @model.viewState.get('listComposerOpen')
              @model.viewState.set('listComposerOpen', false)
            else
              @sidebarView.popView()

          if Controller.showingCalendar(@)
            $('.calendar-day.active').removeClass('active')

          true

  openListComposer: ->
    @model.viewState.openListComposer()

  openCardComposerInFirstList: ->
    firstList = @model.listList.first()
    @model.composer.save({
      list: firstList
      index: firstList.openCards().length
      vis: true
    })
    trackUe('card composer', 'open', '', '', '', 'via navigating to board', { 'boardid': @model.get('id') })
    return

  scrollToList: (list) ->
    Util.scrollElementIntoView @$('#board')[0], @viewForList(list).el,
      horizontal: true
      animated: true
    return

  viewForList: (list) ->
    return @listListView.viewForModel(list)

  scrollToCard: (card) ->
    list = card.getList()
    @scrollToList(list)
    @viewForList(list).scrollToCard(card)

  preventScrollSelection: ->
    # So here's the deal.
    #
    # When you're selecting cards with the keyboard, we'll scroll the
    # board and the lists on it to ensure the currently selected card
    # is always visible.
    #
    # As a result of this scrolling, it's possible that the mouseenter event
    # will fire on a CardView -- which, if you look above at the handling of
    # mouseEnterCardView, will cause us to mark the newly hovered card as
    # selected, even though you didn't actually move the mouse at all.
    #
    # So we remember that we've just selected something with the keyboard,
    # and we should ignore mouse events until the next time the user moves
    # the mouse.
    #
    # But.
    #
    # Chrome will fire mousemove events even when the mouse *hasn't* moved,
    # as a result of the scroll.
    #
    # https://code.google.com/p/chromium/issues/detail?id=241476
    #
    # So we can't just wait for the next mousemove event -- we have to wait
    # for the next mousemove event that has occurred as the result of the
    # user moving the mouse.
    #
    # Detecting that is a bit of a hack, but appears to work well enough for
    # now.
    #
    # IE 10 will apparently just fire mousemove events constantly, even
    # when a scroll doesn't occur. I don't know how to fix that. I can't find
    # a good workaround for IE 10. So that's just not gonna work.

    if @ignoreMouseCardSelects
      return

    isResultOfActualPhysicalMouseMovement = (e) ->
      { movementX: x, movementY: y } = e.originalEvent
      x != 0 || y != 0

    @ignoreMouseCardSelects = true

    bindOnce = =>
      $(document).one 'mousemove', (e) =>
        if isResultOfActualPhysicalMouseMovement(e)
          @ignoreMouseCardSelects = false
        else
          bindOnce()
        return

    bindOnce()
    return

  markRelatedNotificationsRead:  ->
    isRelatedAndUnread = (notification) =>
      notification.get('unread') &&
      !notification.get('data')?.card? &&
      notification.get('data').board?.id == @model.get('id')
    for notification in @modelCache.all('Notification') when isRelatedAndUnread(notification)
      notification.markRead()
    return

  moveCard: (direction) ->
    @preventScrollSelection()

    selectedCard = @model.viewState.getCard()

    if !selectedCard?
      # Select the first card in the first list that has a card
      listWithCards =
        @model.listList.find (list) -> !list.openCards().isEmpty()
      listWithCards?.selectFirstCardInList()
      return

    selectedList = selectedCard.getList()

    openCards = selectedList.openCards()
    cardIndex = openCards.indexOf(selectedCard)

    findNextGoodIndex = (currentIndex, indexDelta, upperBound, fxIndexIsGood) =>
      newIndex = currentIndex + indexDelta
      if @model.filter.isFiltering
        while 0 <= newIndex < upperBound && !fxIndexIsGood(newIndex)
          newIndex += indexDelta
      # We just return something out of bounds if there's no index that works
      return newIndex

    if direction in ['up', 'down']
      indexDelta = if direction == 'up' then -1 else 1
      newCardIndex = findNextGoodIndex cardIndex, indexDelta, openCards.length, (newCardIndex) =>
        @model.filter.satisfiesFilter(openCards.at(newCardIndex))

      if 0 <= newCardIndex < openCards.length
        card = openCards.at(newCardIndex)
        @scrollToCard card
        @model.viewState.selectCard card

    else if direction in ['left', 'right']
      openLists = @model.listList
      listIndex = openLists.indexOf(selectedList)

      listIndexDelta = if direction == 'left' then -1 else 1
      newListIndex = findNextGoodIndex listIndex, listIndexDelta, openLists.length, (newListIndex) =>
        openLists.at(newListIndex).openCards().any (card) =>
          @model.filter.satisfiesFilter(card)
      if 0 <= newListIndex < openLists.length
        newList = openLists.at(newListIndex)
        newListOpenCards = newList.openCards()
        newCardIndexStart = Math.min(cardIndex, newListOpenCards.length - 1)
        for delta in [1, -1]
          newCardIndex = findNextGoodIndex newCardIndexStart - delta, delta, newListOpenCards.length, (newCardIndex) =>
            @model.filter.satisfiesFilter(newListOpenCards.at(newCardIndex))
          if 0 <= newCardIndex < newListOpenCards.length
            card = newListOpenCards.at(newCardIndex)
            @model.viewState.selectCard card
            @scrollToCard card
            break

  renderClosed: ->
    @$el.html closedTemplate({
      name: @model.get('name')
      canReopen: @model.owned()
      canDelete: @model.owned()
      deleting: @model.isDeleting()
    })
    @defaultBoardBackground()
    return

  renderOpen: ->
    isNewBoard = (new Date() - Util.idToDate(@model.id)) < 180000
    if isNewBoard && @model.isFirstOwnedBoard()
      @model.viewState.set("showSidebar", false)
    else
      @model.viewState.setShowSidebarFromPref()

    data = {}
    data.url = Controller.getBoardUrl(@model)
    for preference in @model.prefNames.concat(@model.myPrefNames)
      data["#{preference}_#{@model.getPref(preference)}"] = true
    data.canJoin = @model.canJoin()
    data.canInviteMembers = @model.canInviteMembers()
    data.confirmed = Auth.me().get('confirmed')

    @listListView.$el.detach()
    @$el.html templates.fillFromModel('board', @model)

    @renderBoardHeader()
    @renderBoardWarnings()
    @renderBoardBackground()

    # this prevents the sidebar from animating in when first rendering.
    if @model.viewState.get('showSidebar')
      @$el.addClass('is-show-menu')

    @appendSubview @sidebarView, @$('.js-fill-board-menu')

    @renderSidebarState()
    @renderLists()

    Controller.setLocation(title: data.name)

    @defer =>
      @$('#board').unbind('mousedown.dragscrollable').dragscrollable
        fxIgnore: (event) ->
          boardEl = $(event.target).closest('#board')
          isScrollbar = event.offsetY > (boardEl.height() - 11)
          isList = $(event.target).closest('.js-list-content').length > 0
          isListComposer = $(event.target).closest('.js-add-list').length > 0
          isScrollbar || isList || isListComposer

      DragSort.refreshListSortable()
    return

  render: ->
    if @model.get('closed')
      @renderClosed()
    else
      @renderOpen()

    return @

  renderFilteringStatus: ->
    isFiltering = @model.filter.isFiltering()
    @$('.js-filter-cards-indicator').toggleClass('hide', !isFiltering)
    @$('.js-num-cards').toggleClass('hide', !isFiltering)
    @$('#board').toggleClass('filtering', isFiltering)

    queryString = @model.filter.toQueryString()

    history.replaceState(null, null, location.pathname + queryString)

  removeSidebarDisplayTypes: ->
    @$el.removeClass('sidebar-display-wide')
    return

  renderSidebarDisplayType: ->
    displayClass = @model.viewState.getSidebarDisplayType()
    @$el.addClass(displayClass)
    return

  renderSidebarState: ->
    @renderSidebarDisplayType()

    if @model.viewState.get('showSidebar')
      @showSidebar()
    else
      @hideSidebar()

    return

  toggleSidebar: ->
    @model.viewState.setShowSidebar(!@model.viewState.get('showSidebar'))

  setSidebarShow: ->
    @model.viewState.setShowSidebar(true)
    return

  showSidebar: ->
    @renderSidebarDisplayType()

    # Hacky... the entire transition will be hidden if
    # there isn't a slight delay between unhiding and
    # enabling the transition class.
    clearTimeout @_sidebarHideTimeout
    @$('.js-fill-board-menu').removeClass('hide')
    @defer =>
      @$el.addClass('is-show-menu')

    return

  hideSidebar: ->
    @$el.removeClass('is-show-menu')
    clearTimeout @_sidebarHideTimeout
    # Even though the is-show-menu class moves the menu out of view, we want
    # to also *actually* hide it, so the browser doesn't does something weird
    # when the user does something like Ctrl+F for text that appears in the
    # sidebar.
    #
    # We're delaying the hide because we're giving the CSS transition time to
    # complete.  We could try to trigger off of the transitionEnd event but
    # that can be problematic (if another transition starts before the first
    # one finishes or doesn't happen at all because there isn't actually a
    # change in the property being transitioned)
    #
    # The timeout value we're using here isn't meant to match the length of the
    # transition, but hopefully it's longer than whatever the transition is,
    # but not so short that someone could reasonably hide the menu and then
    # Ctrl+F for something that was on it
    @_sidebarHideTimeout = @setTimeout =>
      @$('.js-fill-board-menu').addClass('hide')
    , 250

    return

  refreshOrganization: ->
    oldOrganization = @modelCache.get('Organization', @model.previous('idOrganization'))
    organization = @model.getOrganization()

    if oldOrganization?
      @stopListening oldOrganization

    if organization?
      for prop in ['name', 'logoHash', 'displayName']
        @listenTo organization, "change:#{prop}",
          @frameDebounce @renderBoardHeader

    # Reload plugins for the directory.
    @model.loadPlugins()

    @renderBoardHeader()

  reloadCustomFields: ->
    if @model.isPluginEnabled(CUSTOM_FIELDS_ID)
      # we need to give the server a second to prevent any race conditions
      # mainly if we were the ones to enable custom fields
      setTimeout =>
        ModelLoader.loadCustomFields(@model.id)
      , 1000

  renderBoardHeader: ->
    isPremOrgAdmin = @model.isPremOrgAdmin(Auth.me())

    # EXPERIMENT: subscribeToWatchOrFollow
    subscribeToWatchOrFollow = getExperiment 'subscribeToWatchOrFollow'
    subscribeString = 'subscribed'
    if subscribeToWatchOrFollow?.inExperiment and subscribeToWatchOrFollow.get('variation') != 'control'
      subscribeString = subscribeToWatchOrFollow.get('variation')

    data =
      name: @model.get('name')
      canRename: isPremOrgAdmin || @model.owned()
      isLoggedIn: Auth.isLoggedIn()
      isAdmin: @model.ownedByMember(Auth.me())
      isPrivateTeam: @model.hasOrganization() && !@model.getOrganization()
      isUntitled: @model.get('name') == l(['untitled board'])
      subscribeString: subscribeString
      canJoin: @model.canJoin()
      canInviteMembers: @model.canInviteMembers()
      selfJoin: @model.allowsSelfJoin()
      canAssign: @model.editable()

    organization = @model.getOrganization()
    if organization?
      data.orgDisplayName = organization.get('displayName')
      data.orgName = organization.get('name')
      data.showCopyButton = _.contains(CopyBoardHeaderButtonTeams, organization.id)
      _hash = organization.get('logoHash')
      if _hash
        data.orgLogoUrl = "#{logoDomain}/#{_hash}/30.png"
        data.orgLogoUrl2x = "#{logoDomain}/#{_hash}/170.png"
      data.hasBusinessClass = organization.isPremium()
      data.isBusinessClass = organization.isBusinessClass()
      data.isEnterprise = organization?.get('idEnterprise')

    @$('.js-board-header').html headerTemplate(data)

    @renderPermissionLevel()
    @renderBoardHeaderDescription()
    @renderBoardHeaderCalendar()
    @renderBoardHeaderSubscribed()
    @renderBoardHeaderCollections()
    @renderFilteringStatus()
    @renderBoardHeaderStarred()
    @renderPluginButtons()
    @renderBoardHeaderFacepile()

    @

  renderBoardWarnings: ->
    $warnings = @$('.js-board-warnings')

    perBoardLimits = Limits.sort(
      Limits.filterByKeys(@model.get('limits'), [
        'cards.openPerBoard',
        'cards.totalPerBoard',
        'checklists.perBoard',
        'labels.perBoard',
        'lists.openPerBoard',
        'lists.totalPerBoard',
        'attachments.perBoard',
      ]).filter (l) -> l.status != 'ok'
    )
    templateMap = {
      'cards.openPerBoard':   'open-cards-per-board-limit',
      'cards.totalPerBoard':  'total-cards-per-board-limit',
      'checklists.perBoard':  'checklists-per-board-limit',
      'labels.perBoard':      'labels-per-board-limit',
      'lists.openPerBoard':   'open-lists-per-board-limit',
      'lists.totalPerBoard':  'total-lists-per-board-limit',
      'attachments.perBoard': 'attachments-per-board-limit',
    }
    isEditable = @model.editable()
    minDismiss = Util.dateBefore(months: 6)
    warnings = perBoardLimits.map (limit) ->
      name = limit.key
      status = if limit.status == "warn"
        "warn"
      else
        "disabled"
      key = "#{templateMap[limit.key]}-#{status}"
      test = => isEditable
      [name, { key, test, minDismiss }]

    dismissWarningName = (name) =>
      "BoardWarning-#{name}-#{ @model.id }"

    warning = _.chain(warnings)
      .filter ([name, { test, minDismiss }]) ->
        if test()
          dismissed = Storage.get(dismissWarningName(name))
          !dismissed || dismissed < minDismiss
      .map ([name, { key }]) ->
        { name, key, dismiss: dismissWarningName(name) }
      .first()
      .value()

    _.chain(warnings)
    .filter ([name, { test }]) ->
      !test() && Storage.get(dismissWarningName(name))?
    .each ([name]) ->
      Storage.unset(dismissWarningName(name))
    .value()

    if warning
      $warnings.removeClass('hide').html warningTemplate({
        canDismiss: Storage.enabled(),
        warning
      })
    else
      $warnings.addClass('hide')

    @

  renderBoardHeaderCollections: ->
    organization = @model.getOrganization()
    if organization && organization.isFeatureEnabled('tags')
      @$('.js-collection,.js-collection-divider').toggleClass('hide', false)

    @

  toggleOpenCollections: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'collections', { resetTo: 'more' }
    track("Board Header", "Collections Button", "Toggle Collections Menu")

    @

  renderPluginButtons: ->
    if @pluginHeaderButtonsView?
      @pluginHeaderButtonsView.requestButtonsDebounced()
    else
      @pluginHeaderButtonsView = @subview PluginHeaderButtonsView, @model
    @appendSubview @pluginHeaderButtonsView, @$('.js-plugin-header-btns')

    @

  renderBoardHeaderStarred: ->
    @$('.js-star-board').toggleClass('board-header-btn-enabled', @model.isStarred())
    @

  toggleStarred: ->
    boardStarList = Auth.me().boardStarList

    if boardStarList.getBoardStar(@model.id)?
      boardStarList.unstarBoard(@model.id)
      track("Board Header", "Unstar Board")
    else
      boardStarList.starBoard(@model.id)
      track("Board Header", "Star Board")

    @

  renderBoardHeaderCalendar: ->
    isEnabled = @model.isPowerUpEnabled('calendar')
    @$('.js-calendar').toggleClass('hide', !isEnabled)
    @

  getAllBackgroundClasses: ->
    [
      'body-custom-board-background'
      'body-custom-board-background-tiled'
      'body-light-board-background'
      'body-dark-board-background'
      'body-ambiguous-board-background'
      'body-default-header'
    ].join(" ")

  defaultBoardBackground: ->
    @clearBoardBackground()
    $('#classic-body').addClass('body-default-header')
    return

  clearBoardBackground: ->
    prefs = @model.get('prefs')
    allBackgroundClasses = @getAllBackgroundClasses()

    $('#classic-body')
    .removeClass(allBackgroundClasses)
    .css
      'background-image': ''
      'background-color': ''

    return

  renderBoardBackground: (waitForImage = false) ->
    @clearBoardBackground()

    prefs = @model.get('prefs')
    $body = $('#classic-body')

    if prefs.backgroundColor?
      hexcolor = @model.getClientBackgroundColor(prefs.background)

      $body.css
        'background-color': hexcolor

      FavIcon.setBackground({ color: hexcolor })

    else
      if Backgrounds.hasOwnProperty(prefs.background)
        # Special handling for our default backgrounds, to avoid using the
        # really huge versions
        url = Util.smallestPreviewBiggerThan(
          prefs.backgroundImageScaled,
          640,
          480
        )?.url ? prefs.backgroundImage
      else
        url = prefs.backgroundImage

      if prefs.backgroundTile
        smallUrl = url
      else
        smallUrl =
          Util.smallestPreviewBiggerThan(
            prefs.backgroundImageScaled
            64
            64
          )?.url ? prefs.backgroundImage


      changeBackgroundImage = =>
        $body.addClass('body-custom-board-background')

        if prefs.backgroundTile
          $body.addClass('body-custom-board-background-tiled')

        brightness = prefs.backgroundBrightness

        if prefs.backgroundTopColor
          topBrightness = Util.calculateBrightness(prefs.backgroundTopColor)

          if brightness != topBrightness
            $body.addClass('body-ambiguous-board-background')

        switch brightness
          when 'light'
            $body.addClass('body-light-board-background')
          when 'dark'
            $body.addClass('body-dark-board-background')


        $body
        .css
          'background-image': "url(\"#{url}\")"

        trackUnsplashViewBySavedUrl url

        FavIcon.setBackground({ url: smallUrl, tiled: prefs.backgroundTile })

      if waitForImage
        Util.waitForImageLoad url
          .then changeBackgroundImage
      else
        changeBackgroundImage()

  renderBoardHeaderSubscribed: ->
    isSubscribed = @model.get('subscribed')
    @$('.js-board-header-subscribed').toggleClass('hide', !isSubscribed)
    @

  renderBoardHeaderDescription: ->
    $desc = @$('.js-fill-desc')
    desc = @model.get('desc')

    if !desc
      $desc.addClass('hide')
      return @

    if desc
      title = desc
    else if @model.editable()
      title = l('click to add a description')

    $desc.attr('title', title)
    $desc.removeClass('hide')

    @

  renameBoard: (e) ->
    Util.stop(e)

    track("Board Header", "Open Rename Board From Title")

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new RenameBoardView({ @model, @modelCache })

    return

  openOrgMenu: (e) ->
    Util.stop(e)

    track("Board Header", "Open Org Menu", $(e.target).closest('.js-open-org-menu').data('boardtype'))

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new BoardHeaderOrgMenuView({ @model, @modelCache })

    return

  renderPermissionLevel: ->
    $perm = @$('#permission-level')
    data =
      permIconClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
      permText: l(['board perms', @model.getPermLevel(), 'name'])

    $perm.html permsTemplate(data)

    $perm.attr 'title', BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)
    canInvite = @model.canInvite(Auth.me())
    @$('.js-manage-board-members').toggle(canInvite)

    @

  postListListRender: ->
    log('render', "rendering inline composer and calculating list layout")
    @renderFilteringStatus()
    DragSort.refreshListCardSortable()

  renderLists: ->
    @listListView.$el.toggleClass 'js-list-sortable', @model.editable()
    @$('.board-canvas').append @listListView.el
    # Render after adding because postListListRender is dumb and wants the
    # #board element to be in the DOM already
    @listListView.render()
    @

  sortCommit: (e, ui) ->
    ui.item.trigger 'movelist', ui

  renderBoardHeaderFacepile: ->
    $target = @$('.js-fill-facepile')
    visibleMembers = @model.orderedVisibleMembers()
    numMembers = visibleMembers.length
    maxVisible = 5
    visibleMembers = visibleMembers.slice(0, maxVisible)

    @$('.js-fill-board-member-count').text(numMembers)
    @$('#member-count').toggleClass('pile', numMembers < 100)
    @$('#member-count').toggleClass('pile-lg', numMembers >= 100)

    subviews = for member in visibleMembers
      @subview(MemberOnBoardView, member, { board: @model })

    if $target.length > 0
      @ensureSubviews(subviews.reverse(), $target)

    @defer ->
      DragSort.refreshDraggableSidebarMembers()

    @

  openAllMembers: (e) ->
    # activated only when there's member overflow from facepile
    Util.stop(e)
    trackUe('board view', 'opens', 'board members breakdown', '', '', 'board-header-button', BoardHeaderAllMembersView)

    PopOver.toggle
      elem: @$('.js-open-show-all-board-members')
      view: BoardHeaderAllMembersView
      options: { @model, @modelCache }

  openAddMembers: (e) ->
    Util.stop(e)
    if maybeDisplayMemberLimitsError($(e.target), @model)
      return
    trackUe('board view', 'adds', 'board member', '', '', 'board-header-button', BoardMembersView)

    if !getExperiment('personalizedInvite').get('enabled')
      view = new BoardMembersView({ @model, @modelCache })
      view.loadOrgData()
    else
      view = new BoardMemberAddMultipleView({ @model, @modelCache })
      view.loadOrgData()

    PopOver.toggle
      elem: $(e.target).closest('.js-open-manage-board-members')
      view: view

    return

  joinBoard: (e) ->
    Util.stop(e)
    if maybeDisplayMemberLimitsError($(e.target), @model, Auth.me())
      return
    @$('.js-join-board').remove()
    @model.joinBoard()
    track("Board Menu", "Join Board via Header")

    return

  changeVis: (e) ->
    Util.stop(e)
    track("Board Header", "Open Change Visibilty via Header")

    PopOver.toggle
      elem: @$('.js-change-vis')
      view: ChangeBoardVisibilityView
      options: { @model, @modelCache }

    return

  addBoardToTeam: (e) ->
    Util.stop(e)
    track("Board Header", "Open Add to a Team menu")

    PopOver.toggle
      elem: @$('.js-add-board-to-team')
      view: BoardAddToOrganizationView
      options: { @model, @modelCache }

  openDesc: (e) ->
    Util.stop(e)
    track("Board Header", "Edit Description Button via Header")

    Dialog.show
      view: new BoardDescView({ @model, @modelCache })
      maxWidth: 500

    return

  toggleCalendar: ->
    if @calendarView
      @navigateToBoardEvent()
    else
      @navigateToCalendarEvent()

  navigateToCalendarEvent: ->
    track("Board Header", "Open Calendar View via Header")
    trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', LegacyPowerUps.calendar)
    @navigateToCalendar()

  navigateToCalendar: ->
    calendarBoardUrl = Controller.getBoardUrl(@model.id, 'calendar')
    Controller.navigate calendarBoardUrl, { trigger: true }

  navigateToBoardEvent: ->
    track("Board Header", "Close Calendar View via Header")
    @navigateToBoard()

  navigateToBoard: ->
    boardUrl = Controller.getBoardUrl(@model.id)
    Controller.navigate boardUrl, { trigger: true }

  isShowingCalendar: -> @calendarView?

  showMemberProfile: (member) ->
    Controller.saveMemberBoardProfileLocation(member, @model.id)

    Dialog.show
      view: new MemberBoardProfileView({ model: member, board: @model, @modelCache })
      maxWidth: 500
      hide: =>
        Controller.setBoardLocation(@model.id)
    return

  showCalendar: (date) ->
    if !@model.isPowerUpEnabled('calendar') || @isShowingCalendar()
      return

    @$('.calendar-btn').addClass('board-header-btn-enabled')
    @$('#board').addClass('hide')

    @calendarView = new CalendarControllerView({ @model, @modelCache })
    @$('.board-canvas').append(@calendarView.render(date).el)
    @calendarView.addedToDOM()

  closeDetailView: ->
    Dialog.hide(true)
    @closeCalendar(false)
    @closeDirectory(false)
    return

  closeCalendar: (navigateToBoard = true) ->
    if @calendarView?
      @calendarView.remove()
      @calendarView = null
      if navigateToBoard
        @navigateToBoard()
      @$('.calendar-btn').removeClass('board-header-btn-enabled')
      @$('#board').removeClass('hide')

      # Hack to resolve a bug where the lists won't have been
      # sized properly if the calendar was visible on initial
      # render (and the board and it's lists were hidden)
      @$('.js-list-name-input').trigger('autosize.resize', false)
    return

  remove: ->
    if @calendarView?
      @calendarView.remove()
    super

  toggleDirectory: ->
    if @directoryView
      @navigateToBoard()
    else
      @navigateToDirectory()

  navigateToDirectory: ->
    marketplaceBoardUrl = Controller.getBoardUrl(@model.id, 'power-ups')
    Controller.navigate marketplaceBoardUrl, { trigger: true }

    # Close the sidebar menu for window sizes that aren't extra large.
    if !WindowSize.fExtraLarge
      @sidebarView.hideSidebar()

  showDirectory: (section, category, idPlugin) ->
    @$('#board').addClass('hide')

    @directoryView = new DirectoryView({ @model, @modelCache, section, category, idPlugin, boardView: @ })
    @$('.board-canvas').append(@directoryView.render().el)

  closeDirectory: (navigateToBoard = true) ->
    if @directoryView?
      @directoryView.remove()
      @directoryView = null
      if navigateToBoard
        @navigateToBoard()
      @$('#board').removeClass('hide')
      @$('.js-list-name-input').trigger('autosize.resize', false)
    return

  openFilter: (e) ->
    Util.stop(e)
    track("Board Header", "Open Filtering via Header")
    @sidebarView.pushView 'filter'
    return

  clearFilters: (e) ->
    Util.stop(e)
    track("Board Header", "Clear Filtering via Header")

    @model.filter.clear()
    return

  openUnsubscribe: (e) ->
    Util.stop(e)

    # EXPERIMENT: subscribeToWatchOrFollow
    subscribeToWatchOrFollow = getExperiment 'subscribeToWatchOrFollow'
    unsubscribeString = 'unsubscribe'
    if subscribeToWatchOrFollow?.inExperiment
      experimentVariation = subscribeToWatchOrFollow.get('variation')
      if experimentVariation == 'watch'
        unsubscribeString = 'unwatch'
      if experimentVariation == 'follow'
        unsubscribeString = 'unfollow'

    Confirm.toggle unsubscribeString,
      elem: $(e.target).closest('.js-board-header-subscribed')[0]
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        track("Board Header", "Unsubscribe")
        @model.subscribe(false)
    return

  dblClickAddListMenu: (e) ->
    Util.stop(e)

    if  @model.editable()
      if $(e.target).closest('.js-list-content').length == 0
        if !@model.viewState.get('listComposerOpen')
          # They didn't click inside a list
          track("Board View", "Open Add List Menu via Double Click")

          PopOver.show
            clientx: e.clientX
            clienty: e.clientY
            view: new AddListPopoverView
              model: @model
              modelCache: @modelCache
              didAddList: (list) => @scrollToList(list)
      else if (list = @model.viewState.getList())?
        $elClicked = @$(document.elementFromPoint(e.clientX, e.clientY))

        if($elClicked.closest('.list-header-name,.card-composer,.list-card').length == 0)
          $card = @$(document.elementFromPoint(e.clientX, e.clientY - 16)).closest('.list-card')

          track("Board View", "Open Card Composer via Double Click")
          @model.composer.save({
            list: list
            index:
              if $card.length
                # Put the composer one spot after the card above where we double clicked
                Math.max($card.closest('.js-list-cards').find('>.list-card').index($card), 0) + 1
              else
                # Put the composer at the top
                0
            vis: true
          })


    return

  reopen: (e) ->
    Util.stop(e)

    @model.reopen()

  delete: (e) ->
    Util.stop(e)

    Confirm.toggle 'delete board',
      elem: e.target
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.startDelete()
        .then =>
          track("Board", "Delete", "Via Closed Board")
        .done()

  updateControllerTitle: ->
    Controller.title(@model.get('name'))

  copyBoard: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$(e.target).closest('.js-copy-board')
      view: new CopyBoardView({ @model, @modelCache })

  # Returns the idList/index to move a card to.  It prefers to move the card
  # above the card that is 'active', and will fall back to inserting the card
  # at the bottom of idListDefault if no card is active
  _insertCardPosition: (idListDefault) ->
    activeCard = @model.viewState.getCard()
    if activeCard?
      idList: activeCard.get('idList')
      index: activeCard.getIndexInList()
    else
      idList: idListDefault
      index: @model.listList.get(idListDefault).cardList.length

  moveCardRequested: (listView, { shortLink, idList }) ->
    { idList, index } = @_insertCardPosition(idList)
    idCard = IdCache.getId('Card', shortLink) ? shortLink

    Card.load(idCard, Payloads.cardMinimal, @modelCache)
    .then (card) =>
      list = @model.listList.get(idList)
      if card.get('idList') == idList || canAddCard({ destinationList: list })
        card.moveToList(list, index)
    .done()

  copyCardRequested: (listView, { shortLink, idList }) ->
    { idList, index } = @_insertCardPosition(idList)
    idCard = IdCache.getId('Card', shortLink) ? shortLink

    Card.load(idCard, Payloads.cardMinimal, @modelCache)
    .then (card) =>
      list = @model.listList.get(idList)

      options = {
        hasChecklists: card.checklistList.length > 0,
        hasAttachments: card.attachmentList.length > 0,
        destinationBoard: @model,
        destinationList: list
      }
      if canAddCard(options)
        card.copyTo
          idList: idList
          pos: @model.listList.get(idList).calcPos(index, card)
    .done()

  showCleanUp: (e) ->
    Util.stop(e)

    track("Board Header", "Show Clean-Up")

    view = new BoardCleanUpView({ @model, @modelCache })
    Dialog.show
      view: view
      maxWidth: 800
      hide: ->
        view.abort()

    return



// WEBPACK FOOTER //
// ./app/scripts/views/board/board-view.coffee